<template>
  <div style="min-height: 100vh">
    <router-view></router-view>

    <van-tabbar v-model="active" route active-color="#FF6C1A" inactive-color="#999998" ref="tabbar">
      <!-- <van-tabbar-item icon="wap-home-o" name="home" to="/"
        >首页</van-tabbar-item
      >
      <van-tabbar-item icon="video-o" name="vote" to="/vote"
        >投票</van-tabbar-item
      >
      <van-tabbar-item to="/publicity" name="publicity" icon="contact"
        >公示</van-tabbar-item
      >
      <van-tabbar-item to="/usercenter" name="usercenter" icon="smile-o"
        >我的</van-tabbar-item
      > -->
      <van-tabbar-item v-for="(item, index) in tabList" :key="'tab_' + index" :to="item.to.name">
        <span>{{ item.title }}</span>
        <template #icon="props">
          <van-image :src="props.active ? item.active : item.normal" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "home",
      tabList: [
        {
          title: "首页",
          to: {
            name: "/",
          },
          normal: require("../assets/img/bar_icon_house_false.png"),
          active: require("../assets/img/bar_icon_house_true.png"),
        },
        {
          title: "投票",
          to: {
            name: "/vote",
          },
          normal: require("../assets/img/bar_icon_toupiao_false.png"),
          active: require("../assets/img/bar_icon_toupiao_true.png"),
        },
        {
          title: "公示",
          to: {
            name: "/publicity",
          },
          normal: require("../assets/img/bar_icon_gongshi_false.png"),
          active: require("../assets/img/bar_icon_gongshi_true.png"),
        },
        {
          title: "我的",
          to: {
            name: "/usercenter",
          },
          normal: require("../assets/img/bar_icon_wode_false.png"),
          active: require("../assets/img/bar_icon_wode_true.png"),
        },
      ],
    };
  },
  mounted() {
    this.getIphone()
  },
  methods: {
    getIphone() {
      let iPhonex_xs = window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812
      let iPhonexsmax = window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896
      let iPhonexr = window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896
      let isIPhone12 =
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 390 &&
        window.screen.height === 844;
      let isIPhone12ProMax =
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 428 &&
        window.screen.height === 926;

      let isIPhone12mini =
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 360 &&
        window.screen.height === 780;

      if (iPhonex_xs || iPhonexsmax || iPhonexr || isIPhone12ProMax || isIPhone12 || isIPhone12mini) {
        this.$refs.tabbar.$el.style.paddingBottom = '30px';
      }

    }
  }
};
</script>

<style lang="less" scoped>
.van-tabbar-item--active {
  color: rgba(255, 108, 25, 1);
}

.van-tabbar-item {
  ::v-deep .van-tabbar-item__icon {
    //   width: 28px;
    //   height: 28px;
    font-size: 28px;

    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
